import React from 'react';
import { AutoAwesome, ViewList } from '@mui/icons-material';
import Toggle from '../utils/Toggle';

const TXT_MODE_GENERATOR = { fr: 'Affichage - Générateur', en: 'Display - Generator', de: 'Anzeige – Generator', es: 'Visualización - Generador', pt: 'Exibição - Gerador' };
const TXT_MODE_SIMPLE = { fr: 'Affichage - Simple', en: 'Display - Simple', de: 'Anzeige – Einfach', es: 'Visualización - Simple', pt: 'Exibição - Simples' };

const DisplayModeToggle = ({
    lang = 'fr',
    value = 'generator',
    onChange,
    disabled = false,
    className = '',
}) => (
    <Toggle
        variant="pill"
        items={[
            {
                value: 'generator',
                icon: <AutoAwesome fontSize="small" />,
                tooltip: TXT_MODE_GENERATOR[lang] || TXT_MODE_GENERATOR.en,
            },
            {
                value: 'simple',
                icon: <ViewList fontSize="small" />,
                tooltip: TXT_MODE_SIMPLE[lang] || TXT_MODE_SIMPLE.en,
            },
        ]}
        value={value}
        onChange={onChange}
        disabled={disabled}
        ariaLabel="Display mode"
        className={`generator-mode-selector${className ? ` ${className}` : ''}`}
    />
);

export default DisplayModeToggle;
